import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DeleteOrderModal from '@pages/OrganizedSales/CreateOrders/PopupModal/CancelOrderModal';
import { useEffect, useMemo, useRef, useState } from 'react';
import DeclineOrderModal from '@pages/OrganizedSales/CreateOrders/PopupModal/DeclineOrderModal';
import moment from 'moment';
import { RootState } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';
import OrderStatusActionStaff, { EStaffsActionMode, IStaffsActionEvent } from './OrderStatusActionStaff';
import Helpers from 'helpers/Helpers';
import OrderManagerApi, { TTypeStatusAPI } from 'apis/api/OrderManager';
import { Tooltip, message } from 'antd';
import { getAllTechnicianZone, getUsersTechnician, updatePageLoadingApi } from '@slice/select.slice';
import { addCreateOrders, getDetailOfOrder, updateOpenCreateModal } from '@slice/orderManager.slice';
import { TTypeStatusMsg } from '@models/OrderManager';
import { ThunkDispatch } from '@reduxjs/toolkit';
import ViewImages from './ModalUpdateImages/ViewImages';
import ConfirmOrderModal from '../PopupModal/ConfirmOrderModal';
import { useStoreUpdateOrder } from '../store';
import { getAllOMConfig } from '@slice/adminConfig.slice';
import { useBaseOrderStore } from '../layoutContentUWR/BaseOrder/BaseOrderStore';

export default function StatusOrder({
  isQAction,
  checkFormDetail,
  setErrorFields,
  valueVAT,
  mst,
  companyName,
  emailVAT,
  address,
  type,
  isChangeTypeOrder,
  timeEndFees,
  timeStartFees,
  detailTraHangSets,
  detailThuNos,
  ContactSĐT,
  ContactCusName,
  cusName,
  SĐT,
  AddressShip,
  CompanyDevice,
  chiNhanh,
  tienThanhToanNew,
  formData,
  useVAT // check bật tắt checkbox VAT
}: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [openCanel, setOpenCancel] = useState<boolean>(false);
  const [openDecline, setOpenDecline] = useState<boolean>(false);
  const uLogin = useSelector((state: RootState) => state.user.account);
  const openCodeCreateModal = useSelector((state: RootState) => state.orderManager.openCodeCreateModal);

  const loadedDataSelect = useSelector((state: RootState) => state.select.loadedData);
  const loadedData = useSelector((state: RootState) => state.admin.loadedData);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  // const detailBase = useSelector((state: RootState) => state.orderManager.detailBase); // huỷ không dùng
  const detailErrors = useSelector((state: RootState) => state.orderManager.detailErrors);
  const detailUpgrades = useSelector((state: RootState) => state.orderManager.detailUpgrades);
  const detailReplace = useSelector((state: RootState) => state.orderManager.detailReplace);
  const detailPayFees = useSelector((state: RootState) => state.orderManager.detailPayFees);
  const detailChenhLechs = useSelector((state: RootState) => state.orderManager.detailChenhLechs);

  const detailDLLG = useSelector((state: RootState) => state.orderManager.detailDLLG);
  const detailTraHang = useSelector((state: RootState) => state.orderManager.detailTraHang);

  const { methods, setInputError } = useBaseOrderStore();

  const configOM = useSelector((state: RootState) => state.admin.configOM);

  const payMethod = useSelector((state: RootState) => state.orderManager.payMethod); // PTTT
  const payedMoney = useSelector((state: RootState) => state.orderManager.payedMoney); // Tiền thực thu
  const payWillMoney = useSelector((state: RootState) => state.orderManager.payWillMoney); // Tiền thanh toán

  const otherCost = useSelector((state: RootState) => state.orderManager.otherCost);
  // const ariseCost = useSelector((state: RootState) => state.orderManager.ariseCost);
  const timePostPone = useSelector((state: RootState) => state.orderManager.timePostPone);

  const productCategoryPMP = useSelector((state: RootState) => state.createOrder.listProductMixDataPaging);
  const productCategoryPMS = useSelector((state: RootState) => state.createOrder.dataProductMixSearch);
  const [numDay, setNumDay] = useState<number>(31);
  const [isPrioritized, setIsPrioritized] = useState<boolean>(false);
  const [CreateTime, setCreateTime] = useState<string | null>(null);
  const [WorkTime, setWordTime] = useState<string | null>(null);
  const [DoneTime, setDoneTime] = useState<string | null>(null);
  const [staffCreate, setStaffCreate] = useState<string>('');
  const [staffConfirm, setStaffConfirm] = useState<string>('');
  const [staffWork, setStaffWork] = useState<string>('');
  const [staffApprove, setStaffApprove] = useState<string>('');
  const [typeOrder, setTypeOrder] = useState<string>(''); // type là cần full text còn key mới là cần id
  const [typeKeyOrder, setTypeKeyOrder] = useState<number>(0); // type là cần full text còn key mới là cần id
  const [modeAction, setModeAction] = useState<EStaffsActionMode[]>([EStaffsActionMode.UNKNOWN]);
  const [timeData, setTimeData] = useState<any>();
  const dataDeviceUpdateOrder = useStoreUpdateOrder(state => state);

  const refPrioritized = useRef<boolean>(false);

  useEffect(() => {
    !loadedData.OMConfigLoaded && dispatch(getAllOMConfig()); // tạo đơn lấy all dữ liệu select bộ
  }, []);

  useMemo(() => {
    return configOM.map(e => {
      if (e.key === 'TimeUpdateAfterComplete') {
        return setTimeData(Number(e.data));
      }
    });
  }, [configOM]);

  // khi component được bật riêng lẻ (mở drawer thao tác nhanh thì sử dụng)
  const proccessDetailBase = (detail: any[], hasEx?: boolean) => {
    const listProMix = [...productCategoryPMP, ...productCategoryPMS];
    const listDetails = [];

    for (let i = 0; i < detail?.length; i++) {
      // kiểm tra có trùng mã sản phẩm + mã bộ trong listDetails không???
      if (detail[i].serial == '' && detail[i].phone == '') {
        const checkExist = listDetails.find(
          dtl => dtl.maSanPham + '' + dtl.maBo + '' == detail[i].maSanPham + '' + detail[i].maBo + ''
        );

        if (checkExist) {
          checkExist['amount'] = (checkExist['amount'] || 1) + 1;
          continue;
        }

        listDetails.push({
          ...detail[i], // giữ lại cái cũ
          setName: listProMix.find(proMix => proMix.maSanPham == detail[i]?.maBo)?.nameDisplay || null,
          // isRequireSP: findPM?.input || 0,
          amount: detail[i].amount || 1
        });

        continue;
      }

      listDetails.push({
        ...detail[i], // giữ lại cái cũ
        setName: listProMix.find(proMix => proMix.maSanPham == detail[i]?.maBo)?.nameDisplay || null,
        amount: 1
        // isRequireSP: findPM?.input || 0
      });
    }

    return listDetails.sort((a, b) => a.amount - b.amount) || [];
  };

  useEffect(() => {
    if (isQAction) {
      !loadedDataSelect.techStaffLoaded && dispatch(getUsersTechnician());
      if (!loadedDataSelect.technicianZoneLoaded) {
        dispatch(getAllTechnicianZone());
      }
    }
  }, [isQAction]);

  useEffect(() => {
    // console.log('rowSelected ', rowSelected);
    if (rowSelected) {
      setTypeOrder(rowSelected.orderType?.name); // cần name còn key là cần id
      setTypeKeyOrder(rowSelected.orderType?.id);

      rowSelected.times?.thoiGianTao &&
        setCreateTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianTao));
      rowSelected.times?.thoiGianBatDau &&
        setWordTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianBatDau));
      rowSelected.times?.thoiGianHoanThanh &&
        setDoneTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianHoanThanh));

      setStaffCreate(rowSelected.staffCreate ? 'NV tạo đơn' : 'Không xác định');
      setStaffConfirm(rowSelected.staffOperate ? 'NV điều hành' : 'Không xác định');
      setStaffApprove(rowSelected.staffApprove ? 'NV duyệt đơn' : 'Không xác định');
      setStaffWork('Không xác định');

      setIsPrioritized(rowSelected.isPrioritized);
      refPrioritized.current = rowSelected.isPrioritized;

      // ROOT ADMIN có toàn quyền trị
      // phần xử lý trạng thái đơn để đặt mode cho status Component
      // này quan trọng lắm nha k được đẻ sai hay sửa lum tung vô nha.. chú ý kỹ vô
      switch (rowSelected?.status?.statusValue) {
        case '1': // đơn mới tạo
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.ACCOUNTANT,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        case '3': // bị hẹn hoặc khách kêu vấn đề gì đó k thực hiện tiếp thì.. điều hành quản + kd + cskh
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '4': // đơn hoàn tất thì kế toán có thể vào để cập nhật tiền (phần này chắc để làm bên mục payment) , cho đh vô để cập nhật sau hoàm tất
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.ACCOUNTANT,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '12': // đơn hợp lệ // khi nào đơn kết thúc thì mới end chuyện điều phối || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        // case '13': // đơn do kỹ thuật huỷ || hiện tại khi kỹ thuật huỷ thì coi như k xử lý chỉ lưu tại sao k nhận làm để đh biết
        //   setModeAction([EStaffsActionMode.OPERATING]);
        //   break;
        case '6': // bị từ chối công nợ thì cho vào để huỷ hay là reorder lại đơn
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '2': // đơn đang thực hiện thì vẫn điều phối lại được luôn + kthuat thao tác  || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.TECHNICIAN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        case '7': // đơn đã điều phối thì vẫn có thể điều phối lại + kthuat thao tác  || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.TECHNICIAN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        default:
          break;
      }
    }
  }, [rowSelected]);

  const callBackDelete = (data: any) => {
    console.log('Cancel order > setState is Cancel Order and reCall api');
  };
  const callBackDecline = (data: any) => {
    console.log('Decline order > setState is Decline Order and reCall api');
  };

  const showMessage = (msg?: string, type?: string) => {
    if (type === 'error') {
      message.error(msg, 10);
    } else {
      message.success(msg);
    }
  };

  const handleRequestOrder = async (type?: any, maDonHang?: string, typeMsg?: TTypeStatusMsg) => {
    try {
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.RequestOrder(type, maDonHang).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');

          dispatch(getDetailOfOrder({ maDonHang: maDonHang, typeOrder: rowSelected.orderType.id }));
          // setTimeout(() => {
          //   dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
          // }, 250);
        } else {
          // SubMsg
          showMessage(res.data.message);
        }
        setTimeout(() => {
          dispatch(updatePageLoadingApi(false));
        }, 250);
      });
    } catch (error) {
      console.log(error);
      dispatch(updatePageLoadingApi(false));
    }
  };

  const handleActionStaff = async (
    type?: TTypeStatusAPI,
    data?: any,
    typeMsg?: TTypeStatusMsg,
    maDonHang?: any,
    typeRequest?: any
  ) => {
    console.log('handleActionStaff', type, data, maDonHang, typeRequest);
    try {
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.ActionStatusOrder(type, data).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          if (typeRequest === 'checkRequest') {
            // showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            // setTimeout(() => {
            //   dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            // }, 250);

            const text: any = typeMsg + 'RequestOrder';
            handleRequestOrder('YeuCauChinhSua', maDonHang, text);
          } else {
            showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            setTimeout(() => {
              dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            }, 250);
          }
        } else {
          // SubMsg
          showMessage(
            t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.${typeMsg}`) + '. Err! ' + res.data.message ||
              '',
            'error'
          );
        }
        setTimeout(() => {
          dispatch(updatePageLoadingApi(false));
        }, 250);
      });
    } catch (error) {
      console.log(error);
      dispatch(updatePageLoadingApi(false));
      showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.${typeMsg}`), 'error');
    }
  };

  // function mergeErrorItems(errorItems) {
  //   const merged = [];

  //   for (const item of errorItems) {
  //     // Tìm xem đã tồn tại object cùng id + oldSerial + registrationPlate chưa
  //     const existIndex = merged.findIndex(
  //       m => m.id === item.id && m.oldSerial === item.oldSerial && m.registrationPlate === item.registrationPlate
  //     );

  //     if (existIndex === -1) {
  //       // Chưa có → push mới
  //       merged.push({ ...item });
  //     } else {
  //       // Đã có → merge
  //       const existing = merged[existIndex];

  //       // Gộp diagnosis
  //       if (item.diagnosis) {
  //         if (existing.diagnosis) {
  //           existing.diagnosis += ';' + item.diagnosis;
  //         } else {
  //           existing.diagnosis = item.diagnosis;
  //         }
  //       }

  //       // Gộp handling
  //       if (item.handling) {
  //         if (existing.handling) {
  //           existing.handling += ';' + item.handling;
  //         } else {
  //           existing.handling = item.handling;
  //         }
  //       }

  //       // Gộp details (nếu có)
  //       if (Array.isArray(item.details) && item.details.length > 0) {
  //         if (!Array.isArray(existing.details)) existing.details = [];
  //         existing.details.push(...item.details);
  //       }

  //       // Ưu tiên field không rỗng
  //       for (const key of Object.keys(item)) {
  //         if (existing[key] === '' || existing[key] === null || existing[key] === undefined) {
  //           existing[key] = item[key];
  //         }
  //       }

  //       merged[existIndex] = existing;
  //     }
  //   }

  //   return merged;
  // }

  // chỉ dành cho nv kto cập nhật lại tiền cho đơn hàng
  const updateLastPayment = async (body: any) => {
    try {
      body &&
        (await OrderManagerApi.UpdatePayment(body).then(res => {
          if (!res.data.error) {
            message.success(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.Success'));
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            dispatch(getDetailOfOrder({ maDonHang: body.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
          } else {
            message.error(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.Error'));
          }
        }));
    } catch (error) {
      console.log('error');
    }
  };

  const productMix = useMemo(() => {
    return [...productCategoryPMP, ...productCategoryPMS];
  }, [productCategoryPMP, productCategoryPMS]);

  const listCateOrder = useMemo(() => {
    if (dataDeviceUpdateOrder.devices.length !== 0) {
      return [...dataDeviceUpdateOrder.devices[0]];
    }
    return [];
  }, [dataDeviceUpdateOrder.devices]);

  const actionStaffsEvents: IStaffsActionEvent = {
    onClick: (e?: any) => {
      console.log('onClick', e);
    },
    // nv Kế toán
    declineOrder: (e?: any) => {
      // console.log('declineOrder', e);

      if (e.length == 0) {
        checkFormDetail && checkFormDetail();
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: false,
        note: e || ''
      };

      handleActionStaff('Approve', body, 'NotApproved');
    },
    approveOrder: (e?: any) => {
      // console.log('approveOrder', e);
      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: true,
        note: e || '',
        hinhThucThanhToan: payMethod || rowSelected.payment.hinhThucThanhToan,
        tienThanhToan: payWillMoney || rowSelected.payment.tienThanhToan || 0,
        tienThucThu: payedMoney || rowSelected.payment.tienThucThu || 0,
        tienDuKien: 0,
        vatAmount: 0
      };
      // 1. Xác định nguồn dữ liệu dựa trên điều kiện
      const dataSource = rowSelected?.orderType?.id === 12 ? detailTraHangSets : rowSelected?.itemDetailsMerg;

      // 2. Chỉ thực hiện map một lần duy nhất
      if (dataSource) {
        body['detailItems'] = dataSource.flatMap(set =>
          (set.details || []).map(item => ({
            id: item.id || 0,
            vehicleType: set.vehicleType || '',
            registrationPlate: set.registrationPlate || '',
            maSanPham: item.maSanPham || '',
            serial: item.serial || '',
            companyId: set.companyId || 0,
            doiXe: set.doiXe || '',
            hanDangKiem: '0001-01-01T00:00:00',
            maBo: item.maBo || '',
            phone: item.phone || '',
            cost: item.cost || 0
          }))
        );
      }
      handleActionStaff('Approve', body, 'Approved');
    },
    approveOrderThuNo: (e?: any) => {
      // 1. Lấy danh sách các đơn nợ đã được tích chọn (checked: true)
      // Lưu ý: Dữ liệu nằm trong ThuNoItems[0].inDebtOrderCodes
      const selectedDebtOrders = rowSelected.ThuNoItems?.[0]?.inDebtOrderCodes?.filter(item => item.checked) || [];

      // 2. Khởi tạo Body
      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: true,
        note: e || '',
        hinhThucThanhToan: payMethod || rowSelected.payment?.hinhThucThanhToan || 'Tiền mặt',
        tienThanhToan: payWillMoney || rowSelected.payment?.tienThanhToan || 0,
        tienThucThu: payedMoney || rowSelected.payment?.tienThucThu || 0,
        tienDuKien: 0,
        vatAmount: rowSelected.payment?.vatAmount || 0,

        // items: Chứa thông tin tài chính của từng dòng nợ
        items: selectedDebtOrders.map(order => ({
          id: order.id || 0,
          cost: order.tienNo || 0,
          vatValue: order.thuVat || 0,
          priceAfterVat: (order.tienNo || 0) + (order.thuVat || 0)
        })),

        // detailItems: Chứa chi tiết xe/thiết bị của từng đơn nợ
        detailItems: selectedDebtOrders.map(order => ({
          id: order.id || 0,
          vehicleType: order.orderType || '', // Ví dụ: "Lắp mới"
          registrationPlate: order.bienSoXe || '',
          maSanPham: '',
          serial: order.serial || '',
          companyId: rowSelected.branchInfo?.id || 0,
          doiXe: '',
          hanDangKiem: '0001-01-01T00:00:00',
          maBo: order.maDonHang || '', // Gán mã đơn nợ cũ vào maBo để đối soát
          phone: rowSelected.customerInfo?.customerPhone || '',
          cost: order.tienNo || 0
        }))
      };

      // 3. Gọi action xử lý (Bỏ comment khi chạy thực tế)
      handleActionStaff('ApproveDebtOrder', body, 'Approved');
    },
    updatePayment: (moneyPayed?: number | null, note?: string) => {
      checkFormDetail && checkFormDetail();
      if (!(moneyPayed >= 0) || moneyPayed == null) {
        showMessage(
          t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.ErrorInput'),
          'error'
        );

        const errorFeilds = [
          {
            name: 'paymented',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);

        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        tienThucThu: moneyPayed, // tiền này nhập tay vào k lấy chỗ nào khác
        orderVat: {
          tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
          mst: mst || rowSelected?.orderVat?.mst,
          address: address || rowSelected?.orderVat?.address,
          vatValue: valueVAT != null && valueVAT != undefined ? valueVAT : rowSelected?.orderVat?.vatValue,
          email: emailVAT || rowSelected?.orderVat?.email
        },
        note: note || ''
      };
      // console.log('updatePayment', moneyPayed, body);
      moneyPayed >= 0 && updateLastPayment(body);
    },
    // nv Điều hành
    assignOrder: (listTech?: any, note?: string) => {
      // console.log('assignOrder', listTech, note);
      const body = {
        maDonHang: rowSelected.maDonHang,
        listStaffExecute: listTech,
        isPrioritized: isPrioritized,
        note: note || ''
      };
      handleActionStaff('Assign', body, 'Assigned');
    },
    restartOrder: (note?: any) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || ''
      };
      handleActionStaff('Reprocess', body, 'Reprocessed');
    },
    changePrior: (note?: any) => {
      if (refPrioritized.current === isPrioritized) return;
      const body = {
        maDonHang: rowSelected.maDonHang,
        priority: isPrioritized
      };
      handleActionStaff('OperatorChangePriority', body, 'ChangedPrior');
    },
    editComplete: (note?: any) => {
      // trong đây các đoạn xử lý bị loop với chỗ khác, rảnh thì gom lại cho dễ sửa về sau
      const body = {
        maDonHang: rowSelected.maDonHang,
        itemSummaries: listCateOrder.map(({ giaBanSi, vatValue, ...rest }) => ({
          ...rest,
          cost: giaBanSi,
          vatValue: useVAT ? vatValue || 0 : 0,
          priceAfterVat: useVAT ? giaBanSi + (giaBanSi * vatValue) / 100 : giaBanSi || 0
        })),
        hinhThucThanhToan: payMethod || '',
        note: note || '',
        tienThucThu: payedMoney || 0,
        tienDuKien: otherCost || 0,
        tienThanhToan: payWillMoney || 0,
        vatAmount: useVAT ? valueVAT || 0 : 0,
        orderVat: useVAT
          ? {
              tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
              mst: mst || rowSelected?.orderVat?.mst,
              address: address || rowSelected?.orderVat?.address,
              vatValue: valueVAT != null && valueVAT != undefined ? valueVAT : rowSelected?.orderVat?.vatValue || '0',
              email: emailVAT || rowSelected?.orderVat?.email
            }
          : {
              tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
              mst: mst || rowSelected?.orderVat?.mst,
              address: address || rowSelected?.orderVat?.address,
              vatValue: '',
              email: emailVAT || rowSelected?.orderVat?.email
            }
      };

      if (
        note.length == 0 ||
        address == '' ||
        emailVAT == '' ||
        mst == '' ||
        companyName == '' ||
        address === null ||
        emailVAT === null ||
        mst === null ||
        companyName === null
      ) {
        checkFormDetail && checkFormDetail();
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }
      const errorFeilds = [
        {
          name: 'noticeText',
          errors: []
        }
      ];
      setErrorFields && setErrorFields(errorFeilds);
      let typeStatus = null;
      if (rowSelected?.orderType?.id == 9) {
        const baseSet: any = [];
        for (let i = 0; i < detailDLLG.length; i++) {
          if (detailDLLG[i].details) {
            for (let j = 0; j < detailDLLG[i].details.length; j++) {
              const product = { ...detailDLLG[i].details[j] };
              const objDetail = {
                vehicleType: detailDLLG[i].vehicleType || '',
                registrationPlate: detailDLLG[i].registrationPlate || '',
                companyId: detailDLLG[i].companyId || 0,
                doiXe: detailDLLG[i].doiXe || '',
                hanDangKiem: detailDLLG[i].hanDangKiem || null,
                ...product
              };
              baseSet.push(objDetail);
            }
          } else {
            baseSet.push({
              ...detailDLLG[i]
            });
          }
        }

        body['items'] = baseSet.map(base => ({
          ...base,
          id: base.id || 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateDaiLyLapGiumAfterComplete';
      }
      if (rowSelected?.orderType?.id == 12) {
        // Gán trực tiếp mảng được tạo ra từ flatMap vào body
        // body['items'] = detailTraHangSets.flatMap(set =>
        //   set.details.map(item => ({
        //     id: item.id || 0,
        //     vehicleType: set.vehicleType || '',
        //     registrationPlate: set.registrationPlate || '',
        //     maSanPham: item.maSanPham || '',
        //     serial: item.serial || '',
        //     companyId: set.companyId || 0,
        //     doiXe: set.doiXe || '',
        //     hanDangKiem: set.hanDangKiem,
        //     maBo: item.maBo || '',
        //     phone: item.phone || '',
        //     cost: item.cost || 0
        //   }))
        // );
        if (rowSelected?.orderType?.id == 12) {
          typeStatus = 'UpdateReturnOrderAfterComplete';

          // 1. Xử lý tạo danh sách 'items' (Phẳng hóa dữ liệu từ detailTraHangSets)
          body['items'] = detailTraHangSets?.flatMap(set =>
            (set.details || []).map(item => ({
              id: item.id || 0,
              vehicleType: set.vehicleType || '',
              registrationPlate: set.registrationPlate || '',
              maSanPham: item.maSanPham || '',
              serial: item.serial || '',
              companyId: set.companyId || 0,
              doiXe: set.doiXe || '',
              hanDangKiem: '0001-01-01T23:00:00',
              maBo: item.maBo || '',
              phone: item.phone || '',
              cost: item.cost || 0
            }))
          );

          // 2. Xử lý tạo danh sách 'itemSummaries'
          body['itemSummaries'] = detailTraHangSets?.flatMap(set => {
            // Nếu có details, map qua details
            if (set.details && set.details.length > 0) {
              return set.details.map(item => {
                const cost = Number(item.cost || 0);
                const vatPercent = Number(item.vatValue || 0);
                return {
                  id: item.id || 0,
                  cost: cost,
                  vatValue: vatPercent,
                  priceAfterVat: cost + (cost * vatPercent) / 100
                };
              });
            } else {
              // Nếu không có details, lấy thông tin từ object cha
              const cost = Number(set.cost || 0);
              const vatPercent = Number(set.vatValue || 0);
              return [
                {
                  id: set.id || 0,
                  cost: cost,
                  vatValue: vatPercent,
                  priceAfterVat: cost + (cost * vatPercent) / 100
                }
              ];
            }
          });
        }
        typeStatus = 'UpdateReturnOrderAfterComplete';
      }

      // if (rowSelected?.orderType?.id == 12) {
      //   // Khởi tạo mảng trong object body
      //   body['itemSummaries'] = [];

      //   for (let i = 0; i < detailTraHangSets.length; i++) {
      //     if (detailTraHangSets[i].details) {
      //       for (let j = 0; j < detailTraHangSets[i].details.length; j++) {
      //         const item = detailTraHangSets[i].details[j];

      //         // Tính toán Price After Vat nếu cần (Cost + Tiền VAT)
      //         const cost = Number(item.cost || 0);
      //         const vatPercent = Number(item.vatValue || 0);
      //         const priceAfterVat = cost + (cost * vatPercent) / 100;

      //         // Push vào body theo format yêu cầu
      //         body['itemSummaries'].push({
      //           id: item.id || 0,
      //           cost: cost,
      //           vatValue: vatPercent,
      //           priceAfterVat: priceAfterVat
      //         });
      //       }
      //     } else {
      //       // Trường hợp không có details, lấy thông tin từ item cha
      //       const parentItem = detailTraHangSets[i];
      //       const cost = Number(parentItem.cost || 0);
      //       const vatPercent = Number(parentItem.vatValue || 0);

      //       body['itemSummaries'].push({
      //         id: parentItem.id || 0,
      //         cost: cost,
      //         vatValue: vatPercent,
      //         priceAfterVat: cost + (cost * vatPercent) / 100
      //       });
      //     }
      //   }

      //   typeStatus = 'UpdateReturnOrderAfterComplete';
      // }

      if (rowSelected?.orderType?.id == 3) {
        body['items'] = [];
        const payfees: any[] = [];
        const PayFees = detailPayFees;
        for (let i = 0; i < PayFees.length; i++) {
          const error = { ...detailPayFees[i] };
          payfees.push({ ...error });
          if (PayFees[i].details) {
            for (let j = 0; j < PayFees[i].details.length; j++) {
              const details = { ...PayFees[i].details };
              const objDetails = {
                ...details,
                id: PayFees[i].details[j].id,
                serial: PayFees[i].details[j].serial || '',
                bs: PayFees[i].bs || '',
                maSanPham: PayFees[i].details[j].maSanPham || '',
                companyId: PayFees[i].companyId || '',
                isCamera: PayFees[i].isCamera || false,
                servicePackName: PayFees[i].servicePackName || '',
                cameraCount: PayFees[i].cameraCount || 0,
                cost: PayFees[i].details[j].cost || 0,
                doiXe: PayFees[i].doiXe || '',
                hanDangKiem:
                  ((moment(PayFees[i].hanDangKiem)?.isValid() || PayFees[i].hanDangKiem?._isValid) &&
                  Number((PayFees[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(PayFees[i].hanDangKiem || '0001-01-01T23:00:00'), false)
                    : null) || null,
                phone: PayFees[i].details[j].phone || '',
                type: 1
              };
              if (details['amount']) {
                for (let k = 0; k < details['amount']; k++) {
                  objDetails['id'] = 0;
                  payfees.push(objDetails);
                }
                continue;
              }
              payfees.push(objDetails);

              // if (
              //   (detailPayFees[i].details[j].isRequireSP == 1 &&
              //     (detailPayFees[i].details[j].serial?.length == 0 || !detailPayFees[i].details[j].serial)) ||
              //   (detailPayFees[i].details[j].isRequireSP == 2 &&
              //     (detailPayFees[i].details[j].phone?.length == 0 || !detailPayFees[i].details[j].phone))
              // ) {
              //   isNotEnoughData = true;
              // }
            }
          }
        }

        // timeEndFees, timeStartFees;
        body['thoiGianDongPhi'] = timeStartFees
          ? Helpers.ConvertDateToMoment(new Date(timeStartFees))
          : rowSelected.thoiGianDongPhi;
        body['thoiGianHetHan'] = timeEndFees
          ? Helpers.ConvertDateToMoment(new Date(timeEndFees))
          : rowSelected.thoiGianHetHan;
        body['items'] = payfees.map(base => ({
          ...base,
          id: base.id || 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateCollectFeeAfterComplete';
      }
      if (
        rowSelected?.orderType?.id == 1 ||
        rowSelected?.orderType?.id == 2 ||
        rowSelected?.orderType?.id == 6 ||
        rowSelected?.orderType?.id == 10
      ) {
        const detailBase = methods.getValues('BaseItems'); // lấy trực tiếp từ store
        // console.log('finishOrder base', detailBase); // cần map lại data vì có những trường k có
        const bases: any = [];
        for (let i = 0; i < detailBase.length; i++) {
          if (detailBase[i].details) {
            for (let j = 0; j < detailBase[i].details.length; j++) {
              const product = { ...detailBase[i].details[j] };

              const objDetail = {
                ...product,
                vehicleType: detailBase[i].vehicleType || '',
                registrationPlate: detailBase[i].registrationPlate || '',
                companyId: detailBase[i].companyId || 0,
                doiXe: detailBase[i].doiXe || '',
                hanDangKiem: detailBase[i].hanDangKiem || null
              };

              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  // objDetail['id'] = product['ids'][k] || 0;
                  bases.push({ ...objDetail });
                  // bases.push({ ...objDetail });
                }
                continue;
              }

              bases.push(objDetail);
            }
          } else {
            bases.push({
              ...detailBase[i]
            });
          }
        }

        body['items'] = bases.map(base => ({
          ...base,
          id: typeof base.id === 'string' ? 0 : base.id, // string là key để form quản lý, gửi thì gửi cái cũ server là số, còn string thì đổi về 0
          vehicleType: base.vehicleType || '',
          registrationPlate: base.registrationPlate || '',
          maSanPham: base.maSanPham || '',
          serial: base.serial || '',
          phone: base.phone || '',
          companyId: base.companyId || 0,
          doiXe: base.doiXe || '',
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateAfterComplete';
      }

      let isNotEnoughData = false;
      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        console.log('finishOrder S.chữa | B.Hành', detailErrors); // cần map lại data
        const productMix = [...productCategoryPMP, ...productCategoryPMS];
        const errors = [];

        for (let i = 0; i < detailErrors.length; i++) {
          let diagnosisNew = '';
          let handlingNew = '';

          // 1. Xử lý ErrorItems[i].errors → gom diagnosis/handling
          if (detailErrors[i].errors?.length > 0) {
            const diagnosisNewTemp = [];
            const handlingNewTemp = [];

            for (let k = 0; k < detailErrors[i].errors.length; k++) {
              const errorItem = detailErrors[i].errors[k];
              const newDiagnosis = errorItem.newDiagnosis?.replaceAll(';', '') || '';

              if (Array.isArray(errorItem.newHandling)) {
                const cleanedHandlingArray = errorItem.newHandling
                  .map(h => h?.replaceAll(';', '').trim())
                  .filter(Boolean);

                if (cleanedHandlingArray.length > 0) {
                  handlingNewTemp.push(...cleanedHandlingArray);
                  diagnosisNewTemp.push(...Array(cleanedHandlingArray.length).fill(newDiagnosis));
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else if (typeof errorItem.newHandling === 'string') {
                const cleanedHandling = errorItem.newHandling.replaceAll(';', '').trim();
                if (cleanedHandling) {
                  handlingNewTemp.push(cleanedHandling);
                  diagnosisNewTemp.push(newDiagnosis);
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else {
                if (newDiagnosis) {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              }
            }

            diagnosisNew = diagnosisNewTemp.join(';');
            handlingNew = handlingNewTemp.join(';');
          }

          // 2. Nếu có details → push từng detail
          if (detailErrors[i].details?.length > 0) {
            for (let j = 0; j < detailErrors[i].details.length; j++) {
              const product = { ...detailErrors[i].details[j] };

              const objDetail = {
                ...product,
                id: product.id || 0,
                errorTpye: detailErrors[i].errorTpye || '',
                oldMaSanPham: detailErrors[i].oldMaSanPham || '',
                oldSerial: detailErrors[i].oldSerial || '',
                oldPhone: detailErrors[i].oldPhone || '',
                phenomenon: detailErrors[i].phenomenon || '',
                note: product.note || '',
                diagnosis: diagnosisNew,
                handling: handlingNew,
                cost:
                  product.cost ??
                  (product.newMaSanPham
                    ? productMix.find(p => p.maSanPham === product.newMaSanPham)?.giaBanSi || 0
                    : 0),
                vehicleType: detailErrors[i].vehicleType || '',
                registrationPlate: detailErrors[i].registrationPlate || '',
                companyId: detailErrors[i].companyId || 0,
                doiXe: detailErrors[i].doiXe || '',
                hanDangKiem:
                  ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                  Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                    : null) || null
              };

              errors.push(objDetail);
              // đoạn này để kiểm tra khi người sửa mà nhập k đủ dữ liệu serial..
              if (
                (detailErrors[i].details[j].isRequireSP == 1 &&
                  (detailErrors[i].details[j].newSerial?.length == 0 || !detailErrors[i].details[j].newSerial)) ||
                (detailErrors[i].details[j].isRequireSP == 2 &&
                  (detailErrors[i].details[j].newPhone?.length == 0 || !detailErrors[i].details[j].newPhone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            // 3. Không có details → push object trống diagnosis/handling nếu không có errors
            const objDetail = {
              id: +detailErrors[i].id || 0,
              vehicleType: detailErrors[i].vehicleType || '',
              oldMaSanPham: detailErrors[i].oldMaSanPham || '',
              oldSerial: detailErrors[i].oldSerial || '',
              registrationPlate: detailErrors[i].registrationPlate || '',
              errorTpye: detailErrors[i].errorTpye || '',
              phenomenon: detailErrors[i].phenomenon || '',
              note: detailErrors[i].note || '',
              companyId: detailErrors[i].companyId || 0,
              doiXe: detailErrors[i].doiXe || '',
              hanDangKiem:
                ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                  ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                  : null) || null,
              diagnosis: diagnosisNew || '',
              handling: handlingNew || '',
              newSerial: '',
              newMaSanPham: '',
              cost: 0,
              oldPhone: detailErrors[i].oldPhone || '',
              newPhone: ''
            };

            errors.push(objDetail);
          }
        }

        body['errors'] = errors;

        // kiểm tra có tạo sửa chữa bảo hành không k??
        if (errors.length == 0) {
          message.warning(t('OrganizedSales.OrderManager.CreateOrder.NotDetailOrder'));
          return;
        }

        if (errors.length == 0) {
          message.warning(t('OrganizedSales.OrderManager.CreateOrder.NotDetailOrder'));
          return;
        }

        typeStatus = 'UpdateRepairAfterComplete';
      }

      if (rowSelected?.orderType?.id == 7) {
        body['items'] = [];

        const upgrades: any[] = [];
        // console.log('event.UpgradeItems', event.UpgradeItems, detailUpgrades, JSON.parse(refDetailUpgrades.current));
        const Upgrades = detailUpgrades;

        for (let i = 0; i < Upgrades.length; i++) {
          if (Upgrades[i].details) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].details.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].details[j].id
              );
              const product = { ...Upgrades[i].details[j] };
              const objDetail = {
                ...product,
                id: Upgrades[i].details[j].id,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].details[j].phone || '',
                serial: Upgrades[i].details[j].serial || '',
                maSanPhamMoi: Upgrades[i].details[j].maSanPham || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null
              };
              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  objDetail['id'] = product['ids'][k] || 0;
                  upgrades.push({ ...objDetail });
                }
                continue;
              }
              upgrades.push(objDetail);
            }
          }
          if (Upgrades[i].products) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].products.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].products[j].id
              );
              const product = { ...Upgrades[i].products[j] };
              const objDetail = {
                ...product,
                id: Upgrades[i].products[j].id,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].products[j].phone || '',
                serial: Upgrades[i].products[j].serial || '',
                serialCu: Upgrades[i].products[j].serialCu || '',
                maSanPhamMoi: Upgrades[i].products[j].maSanPhamMoi || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null
              };
              upgrades.push(objDetail);
            }
          } else {
            isNotEnoughData = true;
          }
        }

        body['items'] = upgrades.map((upgrade: any, index: any) => ({
          ...upgrade,
          vehicleType: upgrade.vehicleType || '',
          registrationPlate: upgrade.registrationPlate || '',
          maSanPhamMoi: upgrade.maSanPhamMoi || '',
          maSanPhamCu: upgrade.maSanPhamCu || '',
          serialCu: upgrade.serialCu || '',
          phoneCu: upgrade.phoneCu || '',
          companyId: upgrade.companyId || 0,
          doiXe: upgrade.doiXe || '',
          priceAfterVat: useVAT ? upgrade.priceAfterVat || 0 : rowSelected.upgradeDetails[index].priceAfterVat || 0,
          vatValue: useVAT ? upgrade.vatValue || 0 : rowSelected.upgradeDetails[index].vatValue || 0,
          hanDangKiem:
            ((moment(upgrade.hanDangKiem)?.isValid() || upgrade.hanDangKiem?._isValid) &&
            Number((upgrade.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(upgrade.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));

        typeStatus = 'UpdateUpgradeAfterComplete';
      }
      if (rowSelected?.orderType?.id == 8) {
        // console.log('finishOrder Tháo lắp lại', null);

        body['items'] = [];

        const replaces: any = [];
        for (let i = 0; i < detailReplace.length; i++) {
          if (detailReplace[i].products) {
            for (let j = 0; j < detailReplace[i].products.length; j++) {
              const product = { ...detailReplace[i].products[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPham && product.maSanPham != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPham)?.giaBanSi || 0
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);

              if (
                // sp thay thế
                (product.isRequireSP == 1 && (product.serial?.length == 0 || !product.serial)) ||
                (product.isRequireSP == 2 && (product.phone?.length == 0 || !product.phone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            replaces.push({
              ...detailReplace[i]
            });
          }

          if (detailReplace[i].details) {
            for (let j = 0; j < detailReplace[i].details.length; j++) {
              const product = { ...detailReplace[i].details[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPhamMoi && product.maSanPhamMoi != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPhamMoi)?.giaBanSi || 0
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);

              if (
                // sp mới...
                (product.isRequireSPMoi == 1 && (product.serialMoi?.length == 0 || !product.serialMoi)) ||
                (product.isRequireSPMoi == 2 && (product.phoneMoi?.length == 0 || !product.phoneMoi))
              ) {
                isNotEnoughData = true;
              }
            }
          }
        }

        body['items'] = replaces.map((replace: any, index: any) => ({
          ...replace,
          oldVehicleType: replace['oldVehicleType'] || '',
          oldRegistrationPlate: replace['oldRegistrationPlate'] || '',
          oldCompanyId: replace['oldCompanyId'] || 0,
          oldDoiXe: replace['oldDoiXe'] || '',
          newVehicleType: replace['newVehicleType'] || '',
          newRegistrationPlate: replace['newRegistrationPlate'] || '',
          newCompanyId: replace['newCompanyId'] || 0,
          newDoiXe: replace['newDoiXe'] || '',
          note: replace['note'] || '',
          serial: replace['serial'] || '',
          phone: replace['phone'] || '',
          maSanPham: replace['maSanPham'] || '',
          serialMoi: replace['serialMoi'] || '',
          phoneMoi: replace['phoneMoi'] || '',
          maSanPhamMoi: replace['maSanPhamMoi'] || '',
          priceAfterVat: useVAT ? replace['priceAfterVat'] || 0 : rowSelected.orderDetails[index]?.priceAfterVat || 0,
          vatValue: useVAT ? replace['vatValue'] || 0 : rowSelected.orderDetails[index]?.vatValue || 0,
          cost: replace['cost'] || 0,
          oldHanDangKiem:
            ((moment(replace.oldHanDangKiem)?.isValid() || replace.oldHanDangKiem?._isValid) &&
            Number((replace.oldHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.oldHanDangKiem || '0001-01-01T23:00:00'))
              : null) || null,
          newHanDangKiem:
            ((moment(replace.newHanDangKiem)?.isValid() || replace.newHanDangKiem?._isValid) &&
            Number((replace.newHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.newHanDangKiem || '0001-01-01T23:00:00'))
              : null) || null
        }));

        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!

        typeStatus = 'UpdateOrderThaoLapLaiAfterComplete';
      }

      if (rowSelected?.orderType?.id == 11) {
        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!

        const sum = (Object.values(formData) as number[]).reduce((acc, curr) => acc + curr, 0);

        body['tienThanhToan'] = tienThanhToanNew > 0 ? tienThanhToanNew : payWillMoney || 0;
        body['tienDaThu'] = sum || 0;

        typeStatus = 'UpdateDebtOrderAfterComplete';
      }

      if (rowSelected?.orderType?.id === 13) {
        const flatDiff = detailChenhLechs.flatMap((item: any) => item.diff || []);

        body['maDonHang'] = rowSelected.maDonHang || '';
        body['customerName'] = cusName || rowSelected.customerInfo?.customerName || '';
        body['customerPhone'] = SĐT || rowSelected.customerInfo?.customerPhone || '';
        body['orderAddress'] = {
          lng: rowSelected.customerInfo?.orderAddress?.lng || 0,
          lat: rowSelected.customerInfo?.orderAddress?.lat || 0,
          address: AddressShip || rowSelected.customerInfo?.orderAddress?.address || ''
        };

        // Map lại mảng diff để đảm bảo đúng định dạng số và chuỗi
        body['diff'] = flatDiff.map((item: any) => ({
          soHoaDon: item.soHoaDon || '',
          thuChenhLech: Number(item.thuChenhLech) || 0
        }));

        body['updateNote'] = note || ''; // Hoặc field ghi chú bạn đang dùng
        body['sdtLienHe'] = ContactSĐT || rowSelected.customerInfo?.sdtLienHe || '';
        body['tenNguoiLienHe'] = ContactCusName || rowSelected.customerInfo?.tenNguoiLienHe || '';
        body['companyName'] = CompanyDevice || rowSelected.companyName || 'AnhDuong';

        // Đảm bảo listKinhDoanh là mảng string
        body['listKinhDoanh'] = detailChenhLechs.flatMap((detail: any) => detail.listKinhDoanh || []);

        typeStatus = 'UpdateDiffOrder';
        // Tiếp tục xử lý gọi API với object body này...
      }

      if (isNotEnoughData) {
        console.log('dừng gọi api vì data k hợp lệ');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValid'), 'error');
        return;
      }

      typeStatus && handleActionStaff(typeStatus, body, 'EditComplete');
    },
    // nv sale hoặc kd
    reOrder: (e?: any) => {
      // chưa dùng đến
      console.log('reOrder', e);
    },

    pendingOrder: (note?: any) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        thoiGianHen: timePostPone && Helpers.ConvertDateToISOString(new Date(timePostPone)),
        note: note || ''
      };
      // check lại coi là
      if (timePostPone == null) {
        // set form date hẹn lắp
        const errorFeilds = [
          {
            name: 'DateDeliver',
            errors: [t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.ChangeTimeDeliverRequire')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.TimePostPoneRequire'), 'error');
        return;
      }
      if (note.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }
      setErrorFields &&
        setErrorFields([
          {
            name: 'noticeText',
            errors: []
          }
        ]);
      handleActionStaff('Pending', body, 'Pended');
    },
    cancelOrder: (note?: string, role?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        reason: note + ' | ' + role || ''
      };

      if (note.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      setErrorFields &&
        setErrorFields([
          {
            name: 'noticeText',
            errors: []
          }
        ]);
      handleActionStaff('Cancel', body, 'Canceled');
    },
    sendFeedBack: (note?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || '',
        isCalled: true
      };
      handleActionStaff('CSCallToCustomer', body, 'SentFeedBack');
    },
    // nv kỹ thuật
    rejectOrder: (note?: string) => {
      if (note.length == 0) {
        checkFormDetail && checkFormDetail();
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        reason: note || '',
        note: ''
      };
      handleActionStaff('Reject', body, 'Rejected');
    },
    getOrder: (note?: string) => {
      // nhận đơn
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || ''
      };
      handleActionStaff('Accept', body, 'Accepted');
    },
    workingOrder: (note?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        startTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || ''
      };
      handleActionStaff('Start', body, 'Started');
    },
    // pauseOrder: async (lyDo?: string, maDonHang?: any, type?: any) => {
    //   const body = {
    //     maDonHang: 'string',
    //     lyDo: 'string'
    //   };
    // },
    finishOrder: async (note?: string, maDonHang?: any, type?: any) => {
      // trong đây các đoạn xử lý bị loop với chỗ khác, rảnh thì gom lại cho dễ sửa về sau
      let isNotEnoughData = false;
      let isNotEnoughBienSo = false;
      const body = {
        maDonHang: rowSelected.maDonHang,
        finishTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || ''
      };
      let typeStatus = null;
      if (
        rowSelected?.orderType?.id == 1 ||
        rowSelected?.orderType?.id == 2 ||
        rowSelected?.orderType?.id == 6 ||
        rowSelected?.orderType?.id == 10
      ) {
        const detailBase = methods.getValues('BaseItems'); // lấy trực tiếp struct daat  từ store
        const isValid = await methods.trigger();
        if (!isValid) {
          const allErrors: any = methods.control._formState.errors.BaseItems;

          console.log('allErrors', allErrors);

          if (allErrors) {
            const firstErrorIndex = allErrors.findIndex(error => error !== undefined);
            if (firstErrorIndex !== -1) {
              console.log('Ô lỗi đầu tiên nằm ở xe thứ mấy:', firstErrorIndex);

              const errorRow = allErrors[firstErrorIndex];
              let detailIdx = 0;
              let subFieldName = '';

              // check nếu lỗi đầu tiên có chi tiết errorRow.details
              if (errorRow.details) {
                // dò tiếp coi phần tử nào đầu tiên bị lỗi
                detailIdx = errorRow.details.findIndex(d => d != null);
                if (detailIdx !== -1) {
                  const subDetailError = errorRow.details[detailIdx];
                  subFieldName = Object.keys(subDetailError)[0];
                  // firstFieldName = `details[${detailIdx}].${subFieldName}`;
                  // firstErrorMessage = subFieldName
                }
              } else {
                // nếu k dò đc details, là lỗi này ngay tại thông tin thiết bị, dòng đó luôn
                subFieldName = Object.keys(errorRow)[0];
              }

              console.log(
                'Thông tin lỗi dòng nào, thứ mấy details, field name:',
                firstErrorIndex,
                detailIdx,
                subFieldName
              );
              setInputError({
                gIdx: firstErrorIndex,
                dIdx: detailIdx,
                fieldName: subFieldName
              });

              //  virtuosoRef.current.scrollToIndex({
              //   index: firstErrorIdx,
              //   align: 'center',
              //   behavior: 'smooth'
              // });
            }
          }
          return;
        }
        // setInputError(null)
        // console.log('finishOrder base', detailBase); // cần map lại data vì có những trường k có
        const bases: any = [];
        for (let i = 0; i < detailBase.length; i++) {
          if (detailBase[i].details) {
            for (let j = 0; j < detailBase[i].details.length; j++) {
              const product = { ...detailBase[i].details[j] };
              const objDetail = {
                vehicleType: detailBase[i].vehicleType || '',
                registrationPlate: detailBase[i].registrationPlate || '',
                companyId: detailBase[i].companyId || 0,
                doiXe: detailBase[i].doiXe || '',
                hanDangKiem: detailBase[i].hanDangKiem || null,
                staffExecute: detailBase[i].staffExecute || '',
                ...product
              };
              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  bases.push(objDetail);
                }
                continue;
              }

              bases.push(objDetail);
            }
          } else {
            bases.push({
              ...detailBase[i]
            });
          }
        }

        body['items'] = bases
          .filter(errF => !errF.staffExecute || errF.staffExecute == uLogin.username)
          .map(base => {
            if ([2, 6, 10].includes(rowSelected?.orderType?.id)) {
              if (!base.registrationPlate || base.registrationPlate.trim() === '') {
                isNotEnoughBienSo = true;
              }
            }

            return {
              ...base,
              id: typeof base.id === 'string' ? 0 : base.id, // string là key để form quản lý, gửi thì gửi cái cũ server là số, còn string thì đổi về 0
              vehicleType: base.vehicleType || '',
              registrationPlate: base.registrationPlate || '',
              maSanPham: base.maSanPham || '',
              serial: base.serial || '',
              phone: base.phone || '',
              companyId: base.companyId || '',
              doiXe: base.doiXe || '',
              hanDangKiem:
                ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
                Number((base.hanDangKiem + '').split('-')[0]) > 2010
                  ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
                  : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
            };
          });

        typeStatus = 'Finish';
      }

      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        const productMix = [...productCategoryPMP, ...productCategoryPMS];
        const errors = [];

        for (let i = 0; i < detailErrors.length; i++) {
          let diagnosisNew = '';
          let handlingNew = '';

          // 1. Xử lý ErrorItems[i].errors → gom diagnosis/handling
          if (detailErrors[i].errors?.length > 0) {
            const diagnosisNewTemp = [];
            const handlingNewTemp = [];

            for (let k = 0; k < detailErrors[i].errors.length; k++) {
              const errorItem = detailErrors[i].errors[k];
              const newDiagnosis = errorItem.newDiagnosis?.replaceAll(';', '') || '';

              if (Array.isArray(errorItem.newHandling)) {
                const cleanedHandlingArray = errorItem.newHandling
                  .map(h => h?.replaceAll(';', '').trim())
                  .filter(Boolean);

                if (cleanedHandlingArray.length > 0) {
                  handlingNewTemp.push(...cleanedHandlingArray);
                  diagnosisNewTemp.push(...Array(cleanedHandlingArray.length).fill(newDiagnosis));
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else if (typeof errorItem.newHandling === 'string') {
                const cleanedHandling = errorItem.newHandling.replaceAll(';', '').trim();
                if (cleanedHandling) {
                  handlingNewTemp.push(cleanedHandling);
                  diagnosisNewTemp.push(newDiagnosis);
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else {
                if (newDiagnosis) {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              }
            }

            diagnosisNew = diagnosisNewTemp.join(';');
            handlingNew = handlingNewTemp.join(';');
          }

          // 2. Nếu có details → push từng detail
          if (detailErrors[i].details?.length > 0) {
            for (let j = 0; j < detailErrors[i].details.length; j++) {
              const product = { ...detailErrors[i].details[j] };

              const objDetail = {
                ...product,
                // id: product.id || 0,
                // nếu có details và details[0] thì gán id của detailErrors
                // id: detailErrors[i].details?.length > 0 ? +detailErrors[i].id || 0 : product.id || 0,
                id: j === 0 ? +detailErrors[i].id || 0 : product.id || 0,
                errorTpye: detailErrors[i].errorTpye || '',
                oldMaSanPham: detailErrors[i].oldMaSanPham || '',
                oldSerial: detailErrors[i].oldSerial || '',
                oldPhone: detailErrors[i].oldPhone || '',
                phenomenon: detailErrors[i].phenomenon || '',
                note: product.note || '',
                diagnosis: diagnosisNew,
                handling: handlingNew,
                // newMaSanPham: product.newMaSanPham ? product.newMaSanPham : '',
                newSerial: product.newSerial ? (product.isRequireSP === 2 ? '' : product.newSerial) : '',
                newPhone: product.newPhone ? (product.isRequireSP === 1 ? '' : product.newPhone) : '',

                cost:
                  product.cost ??
                  (product.newMaSanPham
                    ? productMix.find(p => p.maSanPham === product.newMaSanPham)?.giaBanSi || 0
                    : 0),
                vehicleType: detailErrors[i].vehicleType || '',
                registrationPlate: detailErrors[i].registrationPlate || '',
                companyId: detailErrors[i].companyId || 0,
                doiXe: detailErrors[i].doiXe || '',
                hanDangKiem:
                  ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                  Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                    : null) || null,
                priceAfterVat: useVAT
                  ? product.priceAfterVat || 0
                  : product.cost ??
                    ((product.newMaSanPham
                      ? productMix.find(p => p.maSanPham === product.newMaSanPham)?.giaBanSi || 0
                      : 0) ||
                      0),
                vatValue: useVAT ? product.vatValue || 0 : 0
              };

              errors.push(objDetail);
              // đoạn này để kiểm tra khi người sửa mà nhập k đủ dữ liệu serial..
              if (
                (detailErrors[i].details[j].isRequireSP == 1 &&
                  (detailErrors[i].details[j].newSerial?.length == 0 || !detailErrors[i].details[j].newSerial)) ||
                (detailErrors[i].details[j].isRequireSP == 2 &&
                  (detailErrors[i].details[j].newPhone?.length == 0 || !detailErrors[i].details[j].newPhone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            // 3. Không có details → push object trống diagnosis/handling nếu không có errors
            const objDetail = {
              id: +detailErrors[i].id || 0,
              vehicleType: detailErrors[i].vehicleType || '',
              oldMaSanPham: detailErrors[i].oldMaSanPham || '',
              oldSerial: detailErrors[i].oldSerial || '',
              registrationPlate: detailErrors[i].registrationPlate || '',
              errorTpye: detailErrors[i].errorTpye || '',
              phenomenon: detailErrors[i].phenomenon || '',
              note: detailErrors[i].note || '',
              companyId: detailErrors[i].companyId || 0,
              doiXe: detailErrors[i].doiXe || '',
              hanDangKiem:
                ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                  ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                  : null) || null,
              diagnosis: diagnosisNew || '',
              handling: handlingNew || '',
              newSerial: '',
              newMaSanPham: '',
              cost: 0,
              oldPhone: detailErrors[i].oldPhone || '',
              newPhone: '',
              priceAfterVat: useVAT ? detailErrors[i].priceAfterVat || 0 : 0,
              vatValue: useVAT ? detailErrors[i].vatValue || 0 : 0
            };

            errors.push(objDetail);
          }
        }

        // console.log(mergeErrorItems(data));

        body['repairInfo'] = errors;

        // typeStatus = 'FinishRepair';
        typeStatus = 'FinishRepairV2';

        // điều khiển lỗi nếu chưa nhập đủ thông tin đạng áp dụng cho đơn sửa chữa bảo hành (các sp yc cần có serial hoặc sđt (là Hàng hoá) thì cần nhập data cho trường newSerial)
      }

      if (rowSelected?.orderType?.id == 3) {
        body['items'] = [];
        const payfees: any[] = [];
        const PayFees = detailPayFees;
        for (let i = 0; i < PayFees.length; i++) {
          const error = { ...detailPayFees[i] };
          payfees.push({ ...error });
          if (PayFees[i].details) {
            for (let j = 0; j < PayFees[i].details.length; j++) {
              const details = { ...PayFees[i].details[j] };
              const objDetails = {
                ...details,
                id: PayFees[i].details[j].id,
                serial: PayFees[i].details[j].serial || '',
                bs: PayFees[i].bs || '',
                maSanPham: PayFees[i].details[j].maSanPham || '',
                companyId: PayFees[i].companyId || '',
                isCamera: PayFees[i].isCamera || false,
                servicePackName: PayFees[i].servicePackName || '',
                cameraCount: PayFees[i].cameraCount || 0,
                cost: PayFees[i].details[j].cost || 0,
                doiXe: PayFees[i].doiXe || '',
                priceAfterVat: useVAT ? details.priceAfterVat || 0 : details.cost || 0,
                vatValue: useVAT ? details.vatValue || 0 : 0,
                hanDangKiem:
                  ((moment(PayFees[i].hanDangKiem)?.isValid() || PayFees[i].hanDangKiem?._isValid) &&
                  Number((PayFees[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(PayFees[i].hanDangKiem || '0001-01-01T23:00:00'), false)
                    : null) || null,
                phone: PayFees[i].details[j].phone || '',
                type: 1
              };
              if (details['amount']) {
                for (let k = 0; k < details['amount']; k++) {
                  objDetails['id'] = details['ids'][k] || 0;

                  payfees.push({ ...objDetails });
                }
                continue;
              }
              payfees.push(objDetails);

              if (
                (detailPayFees[i].details[j].isRequireSP == 1 &&
                  (detailPayFees[i].details[j].serial?.length == 0 || !detailPayFees[i].details[j].serial)) ||
                (detailPayFees[i].details[j].isRequireSP == 2 &&
                  (detailPayFees[i].details[j].phone?.length == 0 || !detailPayFees[i].details[j].phone))
              ) {
                isNotEnoughData = true;
              }
            }
            if (
              (detailPayFees[i].isRequireSP == 1 &&
                (detailPayFees[i].serial?.length == 0 || !detailPayFees[i].serial)) ||
              (detailPayFees[i].isRequireSP == 2 && (detailPayFees[i].phone?.length == 0 || !detailPayFees[i].phone))
            ) {
              isNotEnoughData = true;
            }
          }
        }
        body['items'] = payfees.map(base => ({
          ...base,
          id: base.id || 0,
          priceAfterVat: useVAT ? base.priceAfterVat || 0 : base.cost || 0,
          vatValue: useVAT ? base.vatValue || 0 : 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'FinishCollectFee';
      }

      if (rowSelected?.orderType?.id == 7) {
        body['items'] = [];
        const upgrades: any[] = [];
        // console.log('event.UpgradeItems', event.UpgradeItems, detailUpgrades, JSON.parse(refDetailUpgrades.current));
        const Upgrades = detailUpgrades;
        for (let i = 0; i < Upgrades.length; i++) {
          if (Upgrades[i].details) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].details.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].details[j].id
              );
              const product = { ...Upgrades[i].details[j] };
              const objDetail = {
                ...product,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].details[j].phone || '',
                serial: Upgrades[i].details[j].serial || '',
                maSanPhamMoi: Upgrades[i].details[j].maSanPham || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null,
                priceAfterVat: useVAT ? product.priceAfterVat || 0 : product.cost || 0,
                vatValue: useVAT ? product.vatValue || 0 : 0
              };
              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  objDetail['id'] = product['ids'][k] || 0;
                  upgrades.push({ ...objDetail });
                }
                continue;
              }
              upgrades.push(objDetail);
            }
          }

          if (Upgrades[i].products) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].products.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].products[j].id
              );
              const product = { ...Upgrades[i].products[j] };
              const objDetail = {
                ...product,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].products[j].phone || '',
                serial: Upgrades[i].products[j].serial || '',
                serialCu: Upgrades[i].products[j].serialCu || '',
                maSanPhamMoi: Upgrades[i].products[j].maSanPhamMoi || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null,
                priceAfterVat: useVAT ? product.priceAfterVat || 0 : product.cost || 0,
                vatValue: useVAT ? product.vatValue || 0 : 0
              };
              upgrades.push(objDetail);
            }
          } else {
            isNotEnoughData = true;
          }
        }

        body['items'] = upgrades.map(upgrade => {
          if (
            (upgrade.isRequireSP == 1 && (upgrade.serial?.length == 0 || !upgrade.serial)) ||
            (upgrade.isRequireSP == 2 && (upgrade.phone?.length == 0 || !upgrade.phone))
          )
            isNotEnoughData = true;
          return {
            ...upgrade,
            vehicleType: upgrade.vehicleType || '',
            registrationPlate: upgrade.registrationPlate || '',
            maSanPhamMoi: upgrade.maSanPhamMoi || '',
            maSanPhamCu: upgrade.maSanPhamCu || '',
            companyId: upgrade.companyId || 0,
            doiXe: upgrade.doiXe || '',
            priceAfterVat: useVAT ? upgrade.priceAfterVat || 0 : upgrade.cost || 0,
            vatValue: useVAT ? upgrade.vatValue || 0 : 0,
            hanDangKiem:
              ((moment(upgrade.hanDangKiem)?.isValid() || upgrade.hanDangKiem?._isValid) &&
              Number((upgrade.hanDangKiem + '').split('-')[0]) > 2010
                ? Helpers.ConvertDateToISOString(new Date(upgrade.hanDangKiem || '0001-01-01T23:00:00'), false)
                : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
          };
        });
        typeStatus = 'FinishUpgrade';
      }

      if (rowSelected?.orderType?.id == 8) {
        body['items'] = [];

        const replaces: any = [];
        for (let i = 0; i < detailReplace.length; i++) {
          if (detailReplace[i].products) {
            for (let j = 0; j < detailReplace[i].products.length; j++) {
              const product = { ...detailReplace[i].products[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPham && product.maSanPham != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPham)?.giaBanSi || 0
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);
              if (
                // sp thay thế
                (product.isRequireSP == 1 && (product.serial?.length == 0 || !product.serial)) ||
                (product.isRequireSP == 2 && (product.phone?.length == 0 || !product.phone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            replaces.push({
              ...detailReplace[i]
            });
          }

          if (detailReplace[i].details) {
            for (let j = 0; j < detailReplace[i].details.length; j++) {
              const product = { ...detailReplace[i].details[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                // oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || '',
                oldHanDangKiem:
                  ((moment(detailReplace[i]['oldHanDangKiem'])?.isValid() ||
                    detailReplace[i]['oldHanDangKiem']?._isValid) &&
                  Number((detailReplace[i]['oldHanDangKiem'] + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(
                        new Date(detailReplace[i]['oldHanDangKiem'] || '0001-01-01T23:00:00'),
                        false
                      )
                    : null) || null,

                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                // newHanDangKiem: detailReplace[i]['newHanDangKiem'] || '',
                newHanDangKiem:
                  ((moment(detailReplace[i]['newHanDangKiem'])?.isValid() ||
                    detailReplace[i]['newHanDangKiem']?._isValid) &&
                  Number((detailReplace[i]['newHanDangKiem'] + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(
                        new Date(detailReplace[i]['newHanDangKiem'] || '0001-01-01T23:00:00'),
                        false
                      )
                    : null) || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPhamMoi && product.maSanPhamMoi != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPhamMoi)?.giaBanSi
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);
              if (
                // sp mới...
                (product.isRequireSPMoi == 1 && (product.serialMoi?.length == 0 || !product.serialMoi)) ||
                (product.isRequireSPMoi == 2 && (product.phoneMoi?.length == 0 || !product.phoneMoi))
              ) {
                isNotEnoughData = true;
              }
            }
          }
        }

        body['items'] = replaces.map(replace => ({
          ...replace,
          oldVehicleType: replace['oldVehicleType'] || '',
          oldRegistrationPlate: replace['oldRegistrationPlate'] || '',
          oldCompanyId: replace['oldCompanyId'] || 0,
          oldDoiXe: replace['oldDoiXe'] || '',
          newVehicleType: replace['newVehicleType'] || '',
          newRegistrationPlate: replace['newRegistrationPlate'] || '',
          newCompanyId: replace['newCompanyId'] || 0,
          newDoiXe: replace['newDoiXe'] || '',
          note: replace['note'] || '',
          serial: replace['serial'] || '',
          maSanPham: replace['maSanPham'] || '',
          cost: replace['cost'] || 0,
          priceAfterVat: useVAT ? replace['priceAfterVat'] || 0 : replace['cost'] || 0,
          vatValue: useVAT ? replace['vatValue'] : 0,
          oldHanDangKiem:
            ((moment(replace.oldHanDangKiem)?.isValid() || replace.oldHanDangKiem?._isValid) &&
            Number((replace.oldHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.oldHanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null,
          newHanDangKiem:
            ((moment(replace.newHanDangKiem)?.isValid() || replace.newHanDangKiem?._isValid) &&
            Number((replace.newHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.newHanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null
        }));

        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!
        typeStatus = 'FinishOrderThaoLapLai';
      }

      if (rowSelected?.orderType?.id == 11) {
        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!
        typeStatus = 'FinishDebtOrder';
      }

      typeStatus && checkFormDetail && checkFormDetail();
      // cần kiểm tra các sản phẩm trong body có hay k nếu k có thì k gửi báo cần nhập chi tiết các tb

      // 1. Ưu tiên kiểm tra Biển số trước
      if (isNotEnoughBienSo) {
        console.log('Dừng: Thiếu biển số');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValidBienSo'), 'error');
        return; // Thoát hàm ngay lập tức
      }

      // 2. Sau đó mới kiểm tra dữ liệu chung (Serial/Phone...)
      if (isNotEnoughData) {
        console.log('dừng gọi api vì data k hợp lệ');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValid'), 'error');
        return;
      }

      // Nếu vượt qua cả 2, tiến hành gọi API...

      // if (isNotEnoughData) {
      //   console.log('dừng gọi api vì data k hợp lệ');
      //   showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValid'), 'error');
      //   return;
      // }
      // console.log('check lại data body', body);
      // if(body['items'].length == 0 && body['repairInfo'].length == 0)
      typeStatus && handleActionStaff(typeStatus, body, 'Finished', rowSelected.maDonHang, type);
    },
    completeOrder: (note?: string, oldCompany?: string, moreInformation?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        completeTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || '',
        // hinhThucThanhToan: rowSelected.payment.hinhThucThanhToan, // các trường sau có thể thay đổi đó !!!
        // tienThucThu: 4500555,
        // nhưng mà kth thì k có sửa các thông tin khác trừ tiền thực thu và HTTT
        orderVat: {
          tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
          mst: mst || rowSelected?.orderVat?.mst,
          address: address || rowSelected?.orderVat?.address,
          vatValue: (valueVAT != null && valueVAT != undefined && valueVAT) || rowSelected?.orderVat?.vatValue
        }
      };

      let typeStatus = null;

      if (rowSelected?.orderType?.id == 1 || rowSelected?.orderType?.id == 2 || rowSelected?.orderType?.id == 10) {
        typeStatus = 'Complete';
      }
      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        typeStatus = 'CompleteRepair';
        body['tienThanhToan'] = 0;
        body['tienThucThu'] = 0;
        body['chiPhiPhatSinh'] = 0;
        body['hinhThucThanhToan'] = '';
      }
      if (rowSelected?.orderType?.id == 6) {
        typeStatus = 'CompleteChangeCompany';
        body['oldCompany'] = oldCompany || '';
        body['moreInformation'] = moreInformation || '';
      }
      if (rowSelected?.orderType?.id == 7) {
        typeStatus = 'CompleteUpgrade';
      }

      if (rowSelected?.orderType?.id == 3) {
        console.log('Complete T.phí..', null);
        typeStatus = 'CompleteCollectFee';
      }
      if (rowSelected?.orderType?.id == 8) {
        console.log('Complete Tháo..', null);
        body['tienThanhToan'] = 0;
        body['tienThucThu'] = 0;
        body['chiPhiPhatSinh'] = 0;
        typeStatus = 'CompleteThaoLapLai';
        body['tienThucThu'] = 0;
        body['hinhThucThanhToan'] = '';
      }
      if (rowSelected?.orderType?.id == 11) {
        body['tienThucThu'] = rowSelected?.payment?.tienThucThu || 0;
        body['hinhThucThanhToan'] = rowSelected?.payment?.hinhThucThanhToan || '';
        typeStatus = 'CompleteDebtOrder';
      }
      // console.log({ typeStatus, rowSelected, body });
      const valueDetails = proccessDetailBase(rowSelected.itemDetails);
      dispatch(addCreateOrders({ typeStatus, body, rowSelected, valueDetails }));
      dispatch(updateOpenCreateModal(true));
      // handleActionStaff(typeStatus, body, 'Completed');
    }
  };

  const viewStaffAssignStatus = useMemo(() => {
    if (rowSelected?.executeInfo.length != 0 && uLogin.ActionOrder.viewStaffAction) {
      return rowSelected?.executeInfo.map(staff => (
        <div
          key={staff.staffExecute}
          style={{
            color:
              staff.status === 'Accept'
                ? 'rgb(22, 163, 74)'
                : staff.status === 'Wait'
                ? 'rgb(24, 144, 255)'
                : 'rgb(185 28 28)'
          }}
        >
          <span>{staff.staffExecute}</span>: <span>{staff.status}</span>
        </div>
      ));
    } else return <>{t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NotAcceptView')}</>;
  }, [rowSelected?.executeInfo, uLogin]);

  const viewStaffInWait = useMemo(() => {
    if (uLogin.ActionOrder.viewStaffAction) {
      const listWait = rowSelected?.executeInfo.filter(staffF => staffF.status == 'Wait') || [];
      if (rowSelected?.executeInfo.length != 0 && listWait?.length != 0)
        return listWait.map(staff => <span key={staff.staffExecute}>{staff.staffExecute}; </span>);

      return null;
    }
    return rowSelected?.executeInfo?.length != 0 ? (
      <>{t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NotAcceptView')}</>
    ) : null;
  }, [rowSelected?.executeInfo, uLogin]);

  return (
    <div className="p-1 bg-cyan-100  drop-shadow-sm">
      {/* đổi loại đơn thì k cần hiện */}
      {openCodeCreateModal && !isChangeTypeOrder && <ConfirmOrderModal typeOrder="xacnhandonhang" />}
      <div className="flex flex-col space-y-4">
        <div className="text-sx text-gray-500">
          <div className={classNames(CreateTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.CreateTime')}:{' '}
            <span className="text-gray-600 font-semibold">{CreateTime}</span>
          </div>
          <div className={classNames(WorkTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.WorkTime')}:{' '}
            <span className=" text-gray-600  font-semibold">{WorkTime}</span>
          </div>
          <div className={classNames(DoneTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.DoneTime')}:{' '}
            <span className="text-gray-600  font-semibold">{DoneTime}</span>
          </div>
        </div>

        <div className="text-lg text-gray-500 flex flex-row">
          <span className="text-base font-semibold text-blue-500 pr-3">
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.CodeOrder')}: {rowSelected?.maDonHang}
          </span>
          <span
            style={{ backgroundColor: `${rowSelected?.status?.color}` }}
            className="relative text-base whitespace-nowrap text-white w-fit h-fit border rounded px-2"
          >
            {rowSelected?.status?.seen == false && (
              <div className="absolute w-[10px] h-[10px] bg-[#FFD23F] -top-[4px] -right-[4px]  rounded-full"></div>
            )}
            {t(rowSelected?.status?.text)}
          </span>
        </div>
        {rowSelected?.statusVNText === 'Hoàn tất' ? (
          uLogin?.role === 'Operating' && uLogin?.isHeadOfDepartment ? (
            ''
          ) : (
            <ViewImages data={rowSelected} />
          )
        ) : (
          ''
        )}

        {/* khi nào đơn đang tiến trình thì sẽ thấy sl các nv thực hiện | có thể cần sửa lại để khi đang điều cũng thấy mục này */}
        {WorkTime?.length !== 0 && (
          <>
            {rowSelected?.status?.statusValue === '2' && (
              <>
                <div className="text-sx text-gray-500">
                  {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NumberStaffWork')}:{' '}
                  <span className="text-gray-600 font-semibold">
                    {rowSelected?.executeInfo.length}{' '}
                    <Tooltip title={viewStaffAssignStatus}>
                      <span className="btn-remove  hover:text-blue-500 hover:underline cursor-pointer">
                        {'Chi tiết thao tác'}
                      </span>
                    </Tooltip>
                  </span>{' '}
                  {/* cần hiện thêm các nv đã chấp nhận hay chưa cho nv điều hành biết !! */}
                </div>
              </>
            )}

            {viewStaffInWait && (
              <div className="text-sx text-gray-500">
                {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.StaffInWait')}:{' '}
                <span className="text-red-600 font-semibold">{viewStaffInWait}</span>
              </div>
            )}
          </>
        )}

        {/* nếu đơn bị từ chối do kto thì hiện lý do từ chối */}
        {rowSelected?.status?.statusValue === '6' && (
          <>
            <div className="text-sx text-gray-500">
              {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ResionNotApprove')}:{' '}
              <span className="text-gray-600 font-semibold">{rowSelected?.notApproveInfo.note}</span>
            </div>
          </>
        )}

        {/* nếu cskh gọi xác nhận hoàn tất đơn thì sẽ có ghi chú hiện lên */}
        {!uLogin.ActionOrder.noViewFeedback &&
          rowSelected?.status?.statusValue === '4' &&
          rowSelected?.customerServiceCall.isCalled && (
            <>
              <div className="text-sx text-gray-500">
                {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NoteCSCall')}:{' '}
                <span className="text-green-600 font-semibold">{rowSelected?.customerServiceCall?.note}</span>
              </div>
            </>
          )}

        {rowSelected && !isChangeTypeOrder && (
          <OrderStatusActionStaff
            maDonHang={rowSelected?.maDonHang}
            yeuCauChinhSua={rowSelected?.yeuCauChinhSua}
            typeOrder={typeOrder}
            typeKeyOrder={typeKeyOrder}
            confirmOrder={rowSelected?.status || {}}
            modeAction={modeAction}
            type={type}
            actionEvents={actionStaffsEvents}
            isPrioritized={isPrioritized}
            setIsPrioritized={e => setIsPrioritized(e)}
            listStaffAssigned={rowSelected?.executeInfo || []}
            rejectInfo={rowSelected?.rejectInfo || []}
            branchWorkOrder={rowSelected.branchInfo.id}
            payment={rowSelected.payment}
            valueVat={valueVAT}
            outTimeUpdate={
              rowSelected?.status?.statusValue === '4' &&
              moment(rowSelected.times.thoiGianHoanThanh).add(timeData, 'days').isBefore(moment(), 'milliseconds')
            }
          />
        )}
      </div>

      {/* các thao tác từ chối // huỷ đơn cần nhập thông tin thêm để confirm thao tác  */}
      <DeleteOrderModal
        isOpen={openCanel}
        rowSelect={rowSelected}
        callBackClose={() => setOpenCancel(false)}
        callBackRefresh={() => setOpenCancel(false)}
        callBackDelete={callBackDelete}
      />
      <DeclineOrderModal
        isOpen={openDecline}
        rowSelect={rowSelected}
        callBackClose={() => setOpenDecline(false)}
        callBackRefresh={() => setOpenDecline(false)}
        callBackDelete={callBackDecline}
      />
    </div>
  );
}
